import { CustomerApplicationFilterOptions } from "Hooks/Api/apiCustomerApplications";
import { customerApplicationStatus } from "Models/Enums";
import { customerApplicationStatusOptions } from "Models/Enums/MappedEnumOptions";
import { useMemo } from "react";
import { useLocation } from "react-router";
import { isGuid } from "Util/StringUtils";


export function useCustomerApplicationPageParams(): Partial<CustomerApplicationFilterOptions> {
	// http://localhost:5000/approve/customerapplications?status=pending&status=APPROVED&userId=11111111-1111-1111-1111-111111111111
	const { search } = useLocation();

	return useMemo(() => {
		const params = new URLSearchParams(search);

		const rawStatuses = params.getAll("status");
		const sanitizedStatuses = rawStatuses.map(s => s.trim().toUpperCase())
			.filter((s): s is customerApplicationStatus => s in customerApplicationStatusOptions);

		const rawUserIds = params.getAll("userId");
		const sanitizedUserIds = rawUserIds.map(id => id.trim())
			.filter(isGuid);

		return {
			filterByStatus: sanitizedStatuses.length > 0 ? sanitizedStatuses : undefined,
			filterByUserIds: sanitizedUserIds.length > 0 ? sanitizedUserIds : undefined,
		};
	}, [search]);
}